import { Box, Typography } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import NextLink from "components/Reusable/Bit/NextLink"
import Image from "next/image"
import styled from "styled-components"
import colors from "theme/colors"

const getWidth = (isDesktop, isHomePage) => {
  if (isHomePage) {
    return isDesktop ? "288px" : "150px"
  }

  return isDesktop ? "280px" : "150px"
}
const getHeight = (isDesktop, isHomePage) => {
  if (isHomePage) {
    return isDesktop ? "203px" : "106px"
  }

  return isDesktop ? "197px" : "106px"
}

type CardWrapperType = {
  $isHomePage?: boolean
}

const StyledCardWrapper = styled(Box)<CardWrapperType>`
  background-color: ${colors.white};
  box-shadow: 0px 2px 24px 0px #0000001f;
  width: 150px;
  min-height: 154px;
  border-radius: 8px;
  overflow: hidden;

  ${(p) => p.theme.breakpoints.up("md")} {
    width: ${(p) => (p?.$isHomePage ? "288" : "280")}px;
    min-height: ${(p) => (p?.$isHomePage ? "261" : "255")}px;
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: 0.2s all ease-in-out;
    &:hover {
      transform: scale(1.1);
    }
  }
`

const StyledText = styled(Typography).attrs({ variant: "body2" })`
  color: ${colors.black};
  margin-top: 4px;
  padding: 0 8px;
  line-height: 0.92;
  font-family: Speedee, NarkisBlock-Thin, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 19.8px;
  letter-spacing: 0.015em;
  text-align: right;
  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: center;
    font-family: Speedee, NarkisBlock;
    font-size: 24px;
    font-weight: 400;
    line-height: 26.4px;
    letter-spacing: 0.015em;
    text-align: center;
  }
  :hover {
    text-decoration: underline;
  }
`

const CategoryCard = ({ href, onClick, data, isHomePage }) => {
  const isDesktop = useIsDesktop()

  return (
    <NextLink href={href} onClick={onClick}>
      <StyledCardWrapper $isHomePage={isHomePage}>
        <Image
          width={getWidth(isDesktop, isHomePage)}
          height={getHeight(isDesktop, isHomePage)}
          src={data?.image?.imageUrl || "/img/MCBirthdayCover.png"}
          alt={`תמונה של גיפטקארד של: ${data?.image?.alt}`}
        />
        <StyledText>{data?.name}</StyledText>
      </StyledCardWrapper>
    </NextLink>
  )
}

export default CategoryCard
